export class BaseEntityParams {}
